import {GenericModel} from "../../../generic.model";
import {makeModel} from "../../../../service/utils/utils.service";
import {DescriptionModel} from "./description.model";
import {WhenModel} from "../../common/when.model";
import {PickUpModel} from "./pickUp.model";
import {DropOffModel} from "./dropOff.model";

export class VehicleRentalModel extends GenericModel {
    public begin: WhenModel;
    public descriptionArray: DescriptionModel[];
    public duration: number; // {day: 12} maybe week etc
    public end: WhenModel;
    public xId: string;
    public vehicleArray: Array<{ xRef: string }>;
    public pickup: PickUpModel;
    public dropOff: DropOffModel;


    // TODO public productArray: [{xRef: "SP.10"}]
    // TODO TO COMPLETE : dropOff
    // TODO  TO COMPLETE : pickup
    // TODO public travellerArray: [{xRef: "T.1", index: 1}]
    // TODO public vendor: {code: "AL", name: {value: "ALAMO", languageCode: "en"}}

    public getDescriptions(): string {
        return this.descriptionArray.map((description: DescriptionModel): string => description.textLineArray.join('<br>')).join('<br><br>').normalize('NFC');
    }

    protected fromJson(json?: any): boolean {
        this.begin = makeModel(json.begin, WhenModel);
        this.descriptionArray = makeModel(json.descriptionArray, DescriptionModel);
        this.duration = json.duration?.day ?? null;
        this.end = makeModel(json.end, WhenModel);
        this.xId = json.xId ?? null;
        this.vehicleArray = json.vehicleArray ?? null;
        this.pickup = makeModel(json.pickup, PickUpModel);
        this.dropOff = makeModel(json.dropOff, DropOffModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.xId !== null && this.begin !== null && this.end !== null;
    }
}